// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginH1Title {
  font-size: 35px;
}

.loginH2Title {
  font-size: 55px;
  color: #000;
}

.verification-text {
  margin-bottom: 195px;
}

.customer-login-verification-text {
  margin-bottom: 140px;
}

.loginContainer .loginLeft {
  padding: 47px 60px 60px 60px;
}
.loginContainer .loginLeft .form label {
  font-size: 16px;
  font-weight: 500;
}
.loginContainer .loginLeft .form .form-control {
  height: 51px;
  border-radius: 55px;
  border-color: #7e858e;
  padding: 17px 28px;
}
.loginContainer .loginLeft .form .form-control:focus {
  border-color: var(--newOrange) !important;
}
.loginContainer .eyBtn {
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.loginRight {
  background-repeat: no-repeat;
  background-size: cover;
  padding: 60px 42px;
}
.loginRight .middleBox {
  width: 92%;
  height: 92%;
  background: linear-gradient(154.05deg, rgba(255, 255, 255, 0.4) 1.79%, rgba(255, 255, 255, 0.1) 99.46%);
  border-radius: 4px;
  padding: 2px;
  position: relative;
}
.loginRight .middleBox > .middleBox2 {
  background: linear-gradient(150.16deg, rgba(255, 112, 32, 0.8) 0%, rgba(245, 196, 0, 0.8) 98.76%);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  padding: 32px 35px 0 35px;
  border-radius: 0px 4px 4px 0px;
}
.loginRight .middleBox .left {
  position: absolute;
  right: 0;
  top: 20%;
  transform: translateX(50%);
}
.loginRight .middleBox .right {
  position: absolute;
  left: 0;
  bottom: 20%;
  transform: translateX(-50%);
}

.labelControl .form-check-label {
  font-size: 18px !important;
}

@media screen and (max-width: 767.98px) {
  .verification-text {
    margin-bottom: 0px;
  }
  .customer-login-verification-text {
    margin-bottom: 0px;
  }
  .loginContainer .j_login_right {
    padding: 0px 60px 60px;
  }
  .loginContainer .j_login_left {
    padding: 0px 60px 30px;
    border-right: 0px !important;
  }
}
@media screen and (max-width: 480px) {
  .loginContainer .j_login_right {
    padding: 0px 15px 60px;
  }
  .loginContainer .loginLeft {
    padding: 20px 15px;
  }
}
.verifyPageText {
  width: 449px;
  font-size: 15px;
}

@media screen and (max-width: 540px) {
  .verifyPageText {
    max-width: 321px;
  }
}
.eyBtn {
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./src/styles/page/Login.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,eAAA;EACA,WAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAEA;EACI,oBAAA;AACJ;;AAII;EACI,4BAAA;AADR;AAIY;EACI,eAAA;EACA,gBAAA;AAFhB;AAKY;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAHhB;AAKY;EACI,yCAAA;AAHhB;AAQI;EACI,WAAA;EACA,QAAA;EACA,2BAAA;AANR;;AAUA;EACI,4BAAA;EACA,sBAAA;EAEA,kBAAA;AARJ;AAUI;EACI,UAAA;EACA,WAAA;EACA,uGAAA;EAEA,kBAAA;EACA,YAAA;EAEA,kBAAA;AAVR;AAYQ;EACI,iGAAA;EACA,kCAAA;UAAA,0BAAA;EACA,yBAAA;EACA,8BAAA;AAVZ;AAaQ;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,0BAAA;AAXZ;AAcQ;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,2BAAA;AAZZ;;AAmBI;EACI,0BAAA;AAhBR;;AAoBA;EACI;IACI,kBAAA;EAjBN;EAmBE;IACI,kBAAA;EAjBN;EAsBM;IACI,sBAAA;EApBV;EAuBM;IACI,sBAAA;IACA,4BAAA;EArBV;AACF;AA2BA;EAEQ;IACI,sBAAA;EA1BV;EA6BM;IACI,kBAAA;EA3BV;AACF;AA8BA;EACI,YAAA;EACA,eAAA;AA5BJ;;AA8BA;EACI;IACI,gBAAA;EA3BN;AACF;AA+BA;EACI,WAAA;EACA,QAAA;EACA,2BAAA;AA7BJ","sourcesContent":[".loginH1Title {\n    font-size: 35px;\n}\n\n.loginH2Title {\n    font-size: 55px;\n    color: #000;\n}\n\n.verification-text {\n    margin-bottom: 195px;\n}\n\n.customer-login-verification-text {\n    margin-bottom: 140px;\n}\n\n.loginContainer {\n\n    .loginLeft {\n        padding: 47px 60px 60px 60px;\n\n        .form {\n            label {\n                font-size: 16px;\n                font-weight: 500;\n            }\n\n            .form-control {\n                height: 51px;\n                border-radius: 55px;\n                border-color: #7e858e;\n                padding: 17px 28px;\n            }\n            .form-control:focus {\n                border-color: var(--newOrange) !important;\n            }\n        }\n    }\n\n    .eyBtn {\n        right: 15px;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n}\n\n.loginRight {\n    background-repeat: no-repeat;\n    background-size: cover;\n    //background-image: url('../../assets/images/login-right.png');\n    padding: 60px 42px;\n\n    .middleBox {\n        width: 92%;\n        height: 92%;\n        background: linear-gradient(154.05deg, rgba(255, 255, 255, 0.4) 1.79%, rgba(255, 255, 255, 0.1) 99.46%);\n        ;\n        border-radius: 4px;\n        padding: 2px;\n\n        position: relative;\n\n        &>.middleBox2 {\n            background: linear-gradient(150.16deg, rgba(255, 112, 32, 0.8) 0%, rgba(245, 196, 0, 0.8) 98.76%);\n            backdrop-filter: blur(5px);\n            padding: 32px 35px 0 35px;\n            border-radius: 0px 4px 4px 0px;\n        }\n\n        .left {\n            position: absolute;\n            right: 0;\n            top: 20.00%;\n            transform: translateX(50%);\n        }\n\n        .right {\n            position: absolute;\n            left: 0;\n            bottom: 20.00%;\n            transform: translateX(-50%);\n        }\n    }\n}\n\n\n.labelControl {\n    .form-check-label {\n        font-size: 18px !important;\n    }\n}\n\n@media screen and (max-width: 767.98px) {\n    .verification-text {\n        margin-bottom: 0px;\n    }\n    .customer-login-verification-text {\n        margin-bottom: 0px;\n    }\n\n    .loginContainer {\n\n        .j_login_right {\n            padding: 0px 60px 60px;\n        }\n\n        .j_login_left {\n            padding: 0px 60px 30px;\n            border-right: 0px !important;\n        }\n    }\n}\n\n\n\n@media screen and (max-width: 480px) {\n    .loginContainer {\n        .j_login_right {\n            padding: 0px 15px 60px;\n        }\n\n        .loginLeft {\n            padding: 20px 15px;\n        }\n    }\n}\n.verifyPageText{\n    width: 449px;\n    font-size: 15px\n}\n@media screen and (max-width: 540px) {\n    .verifyPageText{\n        max-width: 321px;\n    }\n}\n\n\n.eyBtn {\n    right: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
